<template>
  <b-container fluid>
    <b-row align-h="center" align="center">

      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <!-- <b-img src="@/assets/portadapagos.jpg"  fluid-grow alt="Fluid-grow image"></b-img> -->
            <b-img :src="require('@/assets/agua/'+this.$route.params.municipio+'.jpg')"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12">
            <h4>Da click para continuar con el pago.</h4>
          </b-col>
          <b-col class="mt-3">
            <div>
               <form id="formbbva" method="post" :action="urlAdqr+this.urlAction+'/'">  
               <!-- <form id="formbbva" method="post" :action="'https://prepro.adquiracloud.mx/clb/endpoint/'+this.urlAction+'/'">   -->
                <input class="form-submit-button" type="submit" value=" Realizar Pago ">  <br>
                <b class="input-multi"> Secuencia: </b><input  class="input-multi" name="s_transm" v-model="formData.s_transm"><br> 
                <b class="input-multi"> Referencia:</b><input class="input-multi" name="c_referencia" v-model="formData.c_referencia"><br> 
                <b class="input-multi"> Servicio:</b><input class="input-multi" name="t_servicio" v-model="formData.t_servicio"><br>
                <b class="input-multi"> Importe:</b><input class="input-multi" name="t_importe" v-model="formData.t_importe"><br>               
                <b class="input-multi"> Cliente Id:</b><input class="input-multi" name="param_c_b_1" v-model="formData.param_c_b_1"><br> 
                <b class="input-multi"> Nivel:</b><input class="input-multi" name="param_c_b_2" v-model="formData.param_c_b_2"><br> 
                <b class="input-multi"> Nombre:</b><input class="input-multi" name="param_c_b_3" v-model="formData.param_c_b_3"><br> 
                <b class="input-multi"> Moneda:</b><input class="input-multi" name="param_c_b_4" v-model="formData.param_c_b_4"><br> 
                <b class="input-multi"> Idioma:</b><input class="input-multi" name="param_c_b_5" v-model="formData.param_c_b_5"><br> 
                <b class="input-multi"> Financiamiento:</b><input class="input-multi" name="param_c_b_6" v-model="formData.param_c_b_6"><br> 
                <b class="input-multi"> Periodo:</b><input class="input-multi" name="param_c_b_7" v-model="formData.param_c_b_7"><br> 
                <b class="input-multi"> Email:</b><input class="input-multi" name="param_c_b_8" v-model="formData.param_c_b_8"><br>                
                <b class="input-multi"> Telefono:</b><input class="input-multi" name="param_c_b_9" v-model="formData.param_c_b_9"><br> 
                <b class="input-multi"> Fecha:</b><input class="input-multi" name="param_c_b_10" v-model="formData.param_c_b_10"><br> 
                <b class="input-multi"> HMAC:</b><input class="input-multi" name="param_c_b_17" v-model="formData.param_c_b_17"><br> 
                
              </form>
            </div>  
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>

   
  </b-container>
</template>


<script>
import { mapState} from 'vuex';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    urlAdqr: function(){
        var mpio = this.$route.params.municipio;
        return (mpio.includes('demo')|| mpio.includes('huixa'))?'https://prepro.adquiracloud.mx/clb/endpoint/':'https://www.adquiramexico.com.mx/clb/endpoint/';
      },
    
  },
  data(){
    return{
      urlAction:"",
      formData:{
      }
    }
  },
  components: {
  },
  created: function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.formData = {
      "s_transm" : urlParams.get('s_transm'),
      "c_referencia" : urlParams.get('c_referencia'),
      "param_c_b_1" : urlParams.get('param_c_b_1'),
      "param_c_b_2" : urlParams.get('param_c_b_2'),
      "t_servicio" : urlParams.get('t_servicio'),
      "t_importe" : urlParams.get('t_importe'),
      "param_c_b_3" : urlParams.get('param_c_b_3'),
      "param_c_b_4" : urlParams.get('param_c_b_4'),
      "param_c_b_5" : urlParams.get('param_c_b_5'),
      "param_c_b_6"  : urlParams.get('param_c_b_6'),
      "param_c_b_7" : urlParams.get('param_c_b_7'),
      "param_c_b_8" : urlParams.get('param_c_b_8'),
      "param_c_b_9" : urlParams.get('param_c_b_9'),
      "param_c_b_10" : urlParams.get('param_c_b_10'),
      "param_c_b_17" : urlParams.get('param_c_b_17'),
    },
    this.urlAction = urlParams.get('action')    

  },
  methods:{
    

  },
  validations:{
    
  }
}
</script>
<style>
  .input-multi{
     color: white; 
    border: white;
    font-size : 1px;
  }
  .form-submit-button {
    font-size : 38px;
    padding: 5px;
    background: #372b9e;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
    .form-submit-button:hover {
    background: #b1d1fc;
    color: #fff; 
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
</style>